"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import { fetchAllPromotionalBanners } from "@/api-service/banner";
import { HomeBanner } from "@/packages/types/banner";
import Loader from "../common/LoaderComponent";
import NextImage from "../common/NextImage";

const TriplePromotionalBanner: React.FC = () => {
  const [banners, setBanners] = useState<HomeBanner[]>([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const loadBanners = async () => {
      try {
        const data = await fetchAllPromotionalBanners();
        setBanners(data || []);
      } catch (error) {
        console.error("Error fetching promotional banners:", error);
      } finally {
        setLoading(false);
      }
    };
    loadBanners();
  }, []);

  if (loading) {
    return (
      <section className="max-w-7xl mx-auto px-2 pt-8">
        <div className="h-[400px] flex items-center justify-center bg-gray-100 rounded-xl">
          <Loader label="Loading promotional banners..." size="lg" />
        </div>
      </section>
    );
  }

  return (
    <section className="max-w-7xl mx-auto px-2 pt-1">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {banners?.map((banner) => {
          const imgSrc =
            isMobile && banner.mobileUrl ? banner.mobileUrl : banner.imageUrl;

          return (
            <Link
              key={banner.id}
              href={banner.navigationLink || "#"}
              className="relative h-[120px] sm:h-[200px] md:h-[250px] lg:h-[450px] rounded-xl overflow-hidden shadow-md block"
            >
              <NextImage
                src={imgSrc?.trim() || "/assets/site/images/default.png"}
                alt={banner.fileName || "Promotional Banner"}
                fill
                className="object-cover hover:scale-105 transition-transform duration-300"
              />
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default TriplePromotionalBanner;
